import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

import {Button} from '../../../designSystem/Button'
import {ButtonLink} from '../../../designSystem/ButtonLink'
import {Icon} from '../../../designSystem/Icon'
import {Text} from '../../../designSystem/Text'

interface BackendErrorProps {
  onSupportLinkClick?: () => void
  onReloadClick: () => void
  hasHint?: boolean
}

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const TitleWrapper = styled('div')(
  ({theme}) => css`
    gap: ${theme.layout.spacing.s200}px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: ${theme.layout.spacing.s100}px;
  `
)

const DescriptionWrapper = styled('div')(
  ({theme}) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: ${theme.layout.spacing.s900}px;
  `
)

const ButtonWrapper = styled('div')(
  ({theme}) => css`
    padding-top: ${theme.layout.spacing.s500}px;
    width: 85px;
  `
)

const HintWrapper = styled('div')`
  max-width: 312px;
  text-align: center;
`

export const BackendError = ({
  onReloadClick,
  onSupportLinkClick,
  hasHint
}: BackendErrorProps) => {
  return (
    <Container>
      <TitleWrapper>
        <Icon name="Forbid" colorPath="content.danger.c500" />
        <Text variant="titleM">
          <FormattedMessageWrapper
            id="backendError.title"
            defaultMessage="Something went wrong"
          />
        </Text>
      </TitleWrapper>
      {hasHint && (
        <HintWrapper>
          <Text variant="bodyS">
            <FormattedMessageWrapper
              id="backendError.hint"
              defaultMessage="Try again later or refer to your booking confirmation email"
            />
          </Text>
        </HintWrapper>
      )}
      <ButtonWrapper>
        <Button variant="primary" fullWidth onClick={onReloadClick}>
          <FormattedMessageWrapper
            id="backendError.reloadButton"
            defaultMessage="Reload"
          />
        </Button>
      </ButtonWrapper>
      {onSupportLinkClick && (
        <DescriptionWrapper>
          <Text variant="bodyS">
            <FormattedMessageWrapper
              id="backendError.description"
              defaultMessage="If the problem persists"
            />
          </Text>
          <ButtonLink onClick={onSupportLinkClick} size="md">
            <Text variant="labelS">
              <FormattedMessageWrapper
                id="backendError.contactSupport"
                defaultMessage="Contact support"
              />
            </Text>
          </ButtonLink>
        </DescriptionWrapper>
      )}
    </Container>
  )
}
